import { GraphQLQuery } from '@settings/services/graphQLClient/GraphQLClient';
import gql from 'graphql-tag';

export interface RouteCalculatorSettings {
  calculation_max_radius_km: number; // Максимальная граница для увеличения радиуса поиска
  calculation_radius_step_km: number; // Шаг увеличения радиуса поиска
  min_count_find_routes: number; // Минимальное кол-во маршрутов для остановки увеличения радиуса
}

export interface LoadRouteCalculatorSettingsQueryResponse {
  data: RouteCalculatorSettings;
}

/**
 * Запрос загрузки настроек поиска доставки
 */
export class LoadRouteCalculatorSettingsQuery implements GraphQLQuery<null> {
  readonly query: any;

  readonly variables: null;

  constructor() {
    this.variables = null;
    this.query = gql`
      query __LOAD_CALCULATOR_SETTINGS__ {
        data: CalculateSetting {
          min_count_find_routes
          calculation_radius_step_km
          calculation_max_radius_km
        }
      }
    `;
  }
}
